(ns frontend.view.reports.custom.alj-2.active-deals-per-sop-stage-bar-chart
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn bar-deals-per-stage
  [deals]
  (let [report-pipeline-id (alj/alj-report-pipeline-id)]
    {:series [{:name (loc/tr :oppo/stage)
               :data (->> @session/all-stages
                          (remove :common/disabled?)
                          (cu/filter-by :stage/pipeline report-pipeline-id)
                          (sort-by :common/ord)
                          (map (fn [stage]
                                 (let [stage-id (:db/id stage)]
                                   {:name (:stage/name stage)
                                    :y    (->> deals
                                               (cu/filter-by :oppo/stage stage-id)
                                               (count))})))
                          (vec))}]}))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [active-deals (->> (alj/all-deals)
                              (cu/filter-by :oppo/status :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))
            chart-data (bar-deals-per-stage active-deals)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (doall))
            view-name (loc/tr :total-active-deals-by-SOP-stage)]
        [alj-components/alj-bar-chart
         {:view-name       view-name
          :total-deals     (count active-deals)
          :total-amount    (alj-utils/ticket-size-sum-billions active-deals)
          :report-data     export-data
          :chart-data      chart-data
          :date-state-atom date-state-atom
          :footer-content  [:ol.pl-4.pb-4.mr-4.ml-4
                            [:li.text-size--sm
                             "Closed & Approved stages are not relevant since the above chart represents Active deals only"]]}]))))

